export type ReportGroupByMode = 'none' | 'prompt' | 'source';

export const DEFAULT_REPORT_GROUP_BY_MODE: ReportGroupByMode = 'prompt';

export const REPORT_GROUP_BY_EXPAND_ALL_MAX_GROUPS: Readonly<
    Record<Exclude<ReportGroupByMode, 'none'>, number>
> = {
    prompt: 5,
    source: 5,
};

export const REPORT_GROUP_BY_OPTIONS: {
    readonly id: ReportGroupByMode;
    readonly labelKey: string;
}[] = [
    { id: 'none', labelKey: 'detail.groupBy.menuNone' },
    { id: 'prompt', labelKey: 'detail.groupBy.menuPrompt' },
    { id: 'source', labelKey: 'detail.groupBy.menuSource' },
];

export type ReportEventSortField =
    | 'manual'
    | 'eventTime'
    | 'updatedAt'
    | 'confidence';

export type ReportEventSortDirection = 'asc' | 'desc';

// Mirrors what encodeSortOption/parseSortOption put in the URL, so a typo in
// the options list below fails to compile instead of silently falling back to
// the default sort.
export type ReportEventSortOptionId =
    | 'manual'
    | `${Exclude<ReportEventSortField, 'manual'>}-${ReportEventSortDirection}`;

export interface ReportEventSortOption {
    field: ReportEventSortField;
    direction: ReportEventSortDirection;
}

export const REPORT_EVENT_SORT_OPTIONS: {
    readonly id: ReportEventSortOptionId;
    readonly field: ReportEventSortField;
    readonly direction: ReportEventSortDirection;
    readonly labelKey: string;
}[] = [
    {
        id: 'manual',
        field: 'manual',
        direction: 'asc',
        labelKey: 'detail.sort.manual',
    },
    {
        id: 'eventTime-asc',
        field: 'eventTime',
        direction: 'asc',
        labelKey: 'detail.sort.eventTimeAsc',
    },
    {
        id: 'eventTime-desc',
        field: 'eventTime',
        direction: 'desc',
        labelKey: 'detail.sort.eventTimeDesc',
    },
    {
        id: 'updatedAt-desc',
        field: 'updatedAt',
        direction: 'desc',
        labelKey: 'detail.sort.updatedAtDesc',
    },
    {
        id: 'updatedAt-asc',
        field: 'updatedAt',
        direction: 'asc',
        labelKey: 'detail.sort.updatedAtAsc',
    },
    {
        id: 'confidence-desc',
        field: 'confidence',
        direction: 'desc',
        labelKey: 'detail.sort.confidenceDesc',
    },
    {
        id: 'confidence-asc',
        field: 'confidence',
        direction: 'asc',
        labelKey: 'detail.sort.confidenceAsc',
    },
];

export const DEFAULT_REPORT_EVENT_SORT_OPTION: ReportEventSortOption = {
    field: 'manual',
    direction: 'asc',
};

export interface ReportConfidenceRange {
    min: number;
    max: number;
}

export const DEFAULT_REPORT_CONFIDENCE_RANGE: ReportConfidenceRange = {
    min: 40,
    max: 100,
};
